import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import PendingApprovalsContext from '../../providers/PendingApprovalsContext';
import RescheduleResponseModal from '../students/RescheduleResponseModal';
import IconDone from '../../components/icons/IconDone';
import IconWrong from '../../components/icons/IconWrong';
import IconActivity from '../../components/icons/IconActivity';
import language from '../../variables/language';
import '../../css/reschedule.css';
import IconAccepted from '../../components/icons/IconAccepted';
import IconWaitApprove from '../../components/icons/IconWaitApprove';

const typeLabel = { reschedule: 'Зміна терміну', cancel: 'Скасування', approval: 'Показ теми' };

function timeAgo(dAdd, lang) {
   if (!dAdd) return '';
   const then = new Date(dAdd.replace(' ', 'T'));
   if (isNaN(then.getTime())) return '';
   const minutes = Math.max(0, Math.round((Date.now() - then.getTime()) / 60000));
   if (minutes < 1) return lang.pendingApprovalsJustNow || 'щойно';
   if (minutes < 60) return minutes + lang.minutesShort + ' ' + lang.agoSuffix;
   const hours = Math.round(minutes / 60);
   if (hours < 24) return hours + lang.hoursShort + ' ' + lang.agoSuffix;
   const days = Math.round(hours / 24);
   return days + lang.daysShort + ' ' + lang.agoSuffix;
}

// Right column of the dashboard's bottom row, stacked under
// LastConversationProgress (dashboard/Index.jsx) - flexes to fill whatever
// vertical space is left so the page needs no scroll, its own row list
// scrolling internally instead. Reschedule/cancel rows reuse
// RescheduleResponseModal.jsx as-is (its {type, id, raw} prop shape matches
// PendingApprovalsProvider.jsx's own normalized item shape 1:1); approval
// rows get inline approve/reject mirroring StudentPlatform.jsx's
// handleApprove/handleReject. Own row styling (not the shared
// .platform-request-row alert-box look from the student-card context) -
// that style reads fine for 1-2 items on a single student's page, but gets
// visually noisy once many students' items are listed together here.
export default function PendingApprovalsPanel() {
   const lang = language[language.lang];
   const navigate = useNavigate();
   const { items, loading, reload } = useContext(PendingApprovalsContext);
   const [modalItem, setModalItem] = useState(null);

   const handleApprove = (requestId, e) => {
      e.stopPropagation();
      axios.post('/api/teacher-approval-requests/' + requestId + '/approve', {}, { withCredentials: true })
         .then(reload).catch(err => console.log(err));
   };
   const handleReject = (requestId, e) => {
      e.stopPropagation();
      axios.post('/api/teacher-approval-requests/' + requestId + '/reject', {}, { withCredentials: true })
         .then(reload).catch(err => console.log(err));
   };

   const sorted = [...items].sort((a, b) => (b.dAdd || '').localeCompare(a.dAdd || ''));

   return (
      <div className='pending-approvals-panel dashboard-component'>
         <div className='header-dahs-elem'>
            <span>
               <IconWaitApprove style={{ width: 30, height: 30, fill: 'var(--dashboard-header-icon-color)' }} />
               <p className='txt-c'>{lang.pendingApprovalsTitle}</p>
            </span>
            {!loading ? (
               <span className={'pending-approvals-count' + (sorted.length > 0 ? ' has-items' : '')}>{sorted.length}</span>
            ) : ''}
         </div>
         <div className='platform-request-list'>
            {loading ? (
               Array.from({ length: 3 }).map((_, i) => (
                  <div key={i} className='skeleton-block pending-approvals-row-skeleton'></div>
               ))
            ) : ''}
            {!loading && sorted.length === 0 ? (
               <p className='pending-approvals-empty'>{lang.pendingApprovalsEmpty}</p>
            ) : ''}
            {!loading && sorted.map((item) => (
               <div className={'pending-approvals-row type-' + item.type} key={item.type + '-' + item.id}
                  onClick={() => item.type === 'approval' ? navigate('/students/' + item.studentId) : setModalItem(item)}>
                  <div className='pending-approvals-row-main'>
                     <span>
                        <span className={'platform-request-type-badge type-' + item.type}>{typeLabel[item.type]}</span>
                        <span className='pending-approvals-summary' title={item.summary}>{item.summary}</span>
                     </span>
                  </div>
                  {item.type === 'approval' ? (
                     <div className='pending-approvals-actions'>
                        <div className='student-lessons-icon-btn platform-request-approve' onClick={(e) => handleApprove(item.id, e)} title='Показати'>
                           <IconDone style={{ width: 14, height: 14 }} />
                        </div>
                        <div className='student-lessons-icon-btn platform-request-reject' onClick={(e) => handleReject(item.id, e)} title='Відхилити'>
                           <IconWrong style={{ width: 14, height: 14 }} />
                        </div>
                     </div>
                  ) : (
                     <span className='pending-approvals-time'>{timeAgo(item.dAdd, lang)}</span>
                  )}
               </div>
            ))}
         </div>

         <RescheduleResponseModal key={modalItem ? modalItem.type + '-' + modalItem.id : 'none'}
            isOpen={!!modalItem} item={modalItem}
            onClose={() => setModalItem(null)}
            onResolved={reload} />
      </div>
   );
}
